import React from 'react';
import { Card, CardContent, GridColumn, Icon, Separator } from 'telia-front-react';
import { StartingCompanySelectedPackage } from './StartingCompanyFormModal';

const StartingCompanyModalPackageCard: React.FC<StartingCompanySelectedPackage> = (pkg) => {
  return (
    <GridColumn key={pkg.value} width={['xs-6', 'sm-3']}>
      <Card badgeTop={{ icon: '#check', purpose: 'selected' }} key={pkg.value}>
        <CardContent className="text-center">
          <div>
            <Icon align="middle" modifiers={`#${pkg.icon}`} size="sm" />
          </div>
          <Separator color="invisible" spacing="xxsmall" />
          <p className="text-bold">{pkg.title}</p>
        </CardContent>
      </Card>
    </GridColumn>
  );
};

export default StartingCompanyModalPackageCard;
